import clsx from "clsx";
import { ReactNode } from "react";
import styles from "./Badge.module.css";

export interface BadgeProps {
  className?: string;
  children: ReactNode;
}

/** Small uppercase pill — shape & typography only. The color scheme is injected
 *  by the consumer through `className` (see RoleBadge, the lobby room badge…). */
export const Badge = ({ className, children }: BadgeProps) => (
  <span className={clsx(styles.badge, className)}>
    {children}
  </span>
);

export default Badge;
